module.exports = __webpack_public_path__ + "img/pollution_level_2.8e771ea2.png";